import { all } from 'ramda';
import { useMemo } from 'react';
import { mediaManagerFileChosen, mediaManagerFileChosenTry } from '@wix/bi-logger-media-manager-g6/v2';
import { mediaManagerFileChosenParams } from '@wix/bi-logger-media-manager-g6/v2/types';
import { bi } from '../../../services/loggers/bi';
import { extractCommonBiFieldsFromItems } from '../../bi';
import { isFile } from '../../media-manager-sdk/items';
import { useFileType } from './useFileType';
import { useSearchResultsBI } from '../../../containers/FilesManager/SearchResults/useSearchResultsBI';

export const useTrackItemsSubmittedAnalytics = () => {
  const fileType = useFileType();
  const { searchId, searchMetaInfo } = useSearchResultsBI();

  return useMemo(
    () => ({
      trackMediaManagerFileChosenTry: (items) => {
        if (!all(isFile, items)) {
          return;
        }

        bi.logger().report(mediaManagerFileChosenTry(extractCommonBiFieldsFromItems(items, { fileType })));
      },
      trackMediaManagerFileChosen: ({ items, category, categoryId, searchTerm, orientation, target }) => {
        if (!all(isFile, items)) {
          throw new Error('Cannot submit file selection to bi');
        }

        const firstItem = items[0];

        const params: mediaManagerFileChosenParams = {
          ...extractCommonBiFieldsFromItems(items, { fileType }),
          category,
          categoryId,
          searchTerm,
          orientation,
          target,
          search_id: searchId,
          section_name: firstItem ? searchMetaInfo?.[firstItem.id]?.sectionName : undefined,
          section_index: firstItem ? searchMetaInfo?.[firstItem.id]?.sectionIndex : undefined,
          clicked_file_index: firstItem ? searchMetaInfo?.[firstItem.id]?.itemIndexWithinCategory : undefined,
        };

        bi.logger().report(mediaManagerFileChosen(params));
      },
    }),
    [fileType, searchId, searchMetaInfo],
  );
};
